/*eslint-disable*/
import {
  Card,
  CardContent,
  FormControl,
  Grid,
  Typography,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import _ from "lodash";
import React from "react";
import { Field } from "redux-form";
import store from "store";
import CustomCardHeading from "../../components/CustomCardHeading";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import { required, percentage } from "helpers/ValidationHelpers";
import GroupBenefits from "./components/GroupBenifits.jsx";
import Retirement from "./components/Retirement.jsx";
import ApprovedFunds from "./components/ApprovedFunds.jsx";

const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value
  };
};

class RetirementFund extends React.Component {
  componentDidMount() {
    this.props.scrollMeBar();
  }

  checkItem = (label, name) => {
    return (
      <React.Fragment>
        <Grid item xs={12} sm={12} md={12}>
          <Grid container>
            <GridItem
              xs={12}
              sm={12}
              md={6}
              style={{ marginBottom: "30px", position: "relative" }}
            >
              <Typography
                variant="body1"
                style={{
                  position: "absolute",
                  top: "25%"
                }}
              >
                {label}
              </Typography>
            </GridItem>
            <GridItem xs={12} sm={12} md={6} style={{ marginBottom: "30px" }}>
              <FormControl>
                <Field
                  component={FormCheckbox}
                  name={name}
                  onChange={() => {
                    this.forceUpdate();
                  }}
                />
              </FormControl>
            </GridItem>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    let { checkValidation } = this.props;

    let retirement_fund = _.get(
      store.getState().form,
      "newfna.values.retirement_fund",
      {}
    );

    return (
      <div className="contentWithStepper">
        <Card>
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={"Client Name"}
              headline={"Retirement Fund Provisions"}
            />
            <Grid container>
              {this.checkItem(
                "Is this an aproved fund?",
                "retirement_fund.approved_fund"
              )}
              <GridItem xs={12} sm={12} md={12} style={{ overflowX: "auto" }}>
                <GroupBenefits
                  checkValidation={checkValidation}
                  forceUpdate={() => this.forceUpdate()}
                />
              </GridItem>

              {/* Retirement */}
              <GridItem
                xs={12}
                sm={12}
                md={12}
                style={{ marginTop: "40px", overflowX: "auto" }}
              >
                <Retirement checkValidation={checkValidation} />
              </GridItem>

              {retirement_fund.approved_fund ? (
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ marginTop: "40px", overflowX: "auto" }}
                >
                  <ApprovedFunds checkValidation={checkValidation} />
                </GridItem>
              ) : null}
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default RetirementFund;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/RetirementFund/RetirementFund.jsx